import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	underReview: {
		id: 'business-fields.dev-summary.cell.read.lozenge.under-review',
		defaultMessage: 'Under review',
		description: 'Tag text to show that the ticket is under review',
	},
	merged: {
		id: 'business-fields.dev-summary.cell.read.lozenge.merged',
		defaultMessage: 'Merged',
		description: 'Tag text to show that the ticket was merged',
	},
	commit: {
		id: 'business-fields.dev-summary.cell.read.lozenge.commit',
		defaultMessage: '{count, plural, one {# commit} other {# commits}}',
		description: 'Tooltip text to show how many commits have been done for the ticket',
	},
	pullRequest: {
		id: 'business-fields.dev-summary.cell.read.lozenge.pull-request',
		defaultMessage: '{count, plural, one {# pull request} other {# pull requests}}',
		description: 'Tooltip text to show how many pull requests have been done for the ticket',
	},
});
